export default __webpack_public_path__ + "static/media/english-to-tagalog-screenshot-04.2203e822.png";